import * as Yup from "yup";
const nameRegex = /^[A-Za-z]+(?: [A-Za-z]+)*$/;

export const billingDetailsValidationSchema = Yup.object({
  first_name: Yup.string()
    .transform((value) => value?.trim())
    .matches(nameRegex, "Only alphabets and single spaces are allowed")
    .min(1, "Min 1 character required")
    .max(50, "Max 50 characters allowed")
    .required("First Name is required"),

  last_name: Yup.string()
    .transform((value) => value?.trim())
    .matches(nameRegex, "Only alphabets and single spaces are allowed")
    .min(1, "Min 1 character required")
    .max(50, "Max 50 characters allowed")
    .required("Last Name is required"),

  phoneNumber: Yup.string()
    .matches(/^[0-9]{10}$/, "Enter a valid 10-digit phone number")
    .required("Phone Number is required"),
  address: Yup.string()
    .min(3, "Min 3 characters required")
    .max(200, "Max 200 characters allowed")
    .required("Address is required"),
  city: Yup.string()
    .matches(/^[A-Za-z0-9\s]+$/, "Please select a city")
    .required("City is required"),
  state: Yup.string()
    .matches(/^[A-Za-z0-9\s]+$/, "Please select a state")
    .required("State is required"),
  country: Yup.string().required("Country is required"),
  pincode: Yup.string()
    .matches(/^[0-9]{5}$/, "Enter a valid 5-digit zipcode")
    .required("Zipcode is required"),
});
